import {
  ACTION,
  ATTENTIVE_BOOST_EVENT,
  ATTENTIVE_LISTENING_ORIGIN,
  ATTENTIVE_USER_INFO_KEY,
  INTEGRATION_STATUS_ACTIVE,
  USER_ACTION,
} from '../../analytic/constants';
import { getLocalStorage, setLocalStorage } from '.';

export const INTEGRATION_NAME_ATTENTIVE = 'attentive';

export const initReceiveEventAttentive = () => {
  // Event listener to process messages from sign-up unit via postMessage()
  console.log('initReceiveEventAttentive');
  window.addEventListener('message', (e) => {
    try {
      const attentiveUserInfo = getLocalStorage(ATTENTIVE_USER_INFO_KEY) || {};
      if (e.origin === ATTENTIVE_LISTENING_ORIGIN) {
        // EMAIL
        if (e.data?.__attentive?.email) {
          // console.log('email:', e.data.__attentive.email);
          attentiveUserInfo.email = e.data.__attentive.email;
        }
        // PHONE
        if (e.data?.__attentive?.phone) {
          // console.log('phone:', e.data.__attentive.phone);
          attentiveUserInfo.phone = e.data.__attentive.phone;
        }

        if (attentiveUserInfo?.email || attentiveUserInfo?.phone) {
          setLocalStorage(ATTENTIVE_USER_INFO_KEY, attentiveUserInfo);
        }
      }
    } catch (error) {
      console.error('Error parsing attentive user info:', error);
    }
  });
};

export const getAttentiveUserInfo = () => {
  const attentiveUserInfo = getLocalStorage(ATTENTIVE_USER_INFO_KEY);
  return attentiveUserInfo;
};

export const isAttentiveActive = () => {
  const env = window.boostWidgetIntegration?.env;
  const integration = window.boostWidgetIntegration?.app?.[env]?.integration;
  const attentiveStatus = integration?.emailSMS?.attentive?.status;
  const userInfo = getAttentiveUserInfo();
  // Check if Attentive is active and user info is available
  // console.log('Attentive Status:', userInfo);
  if (attentiveStatus === INTEGRATION_STATUS_ACTIVE && (userInfo?.email || userInfo?.phone)) {
    // NOTE: update condition here later when Attentive API Identity is public
    return true;
  }
  return false;
};

export const getAttentiveInfo = (event) => {
  const userInfo = getAttentiveUserInfo();

  let eventName = '';
  switch (event.u) {
    case USER_ACTION.VIEW_PRODUCT:
      if (event.pid) {
        if (event.a === ACTION.RECOMMEND && event.wid) {
          eventName = ATTENTIVE_BOOST_EVENT.CLICK_RECOMMENDATION;
        } else {
          if (event.pg !== 'collection_page') {
            eventName = ATTENTIVE_BOOST_EVENT.CLICK_SEARCH_RESULT;
          } else {
            eventName = ATTENTIVE_BOOST_EVENT.CLICK_PRODUCT;
          }
        }
      }
      break;

    case USER_ACTION.ADD_TO_CART:
      if (event.actionBundle) {
        try {
          const dynamicBundle = JSON.parse(sessionStorage.DynamicBundleDataSession);
          if (dynamicBundle[event.wid]) {
            eventName = ATTENTIVE_BOOST_EVENT.ADD_BUNDLE_TO_CART;
          }
        } catch (e) {
          console.log('Error parsing dynamic bundle');
        }
      } else if (event.pid) {
        eventName = ATTENTIVE_BOOST_EVENT.ADD_TO_CART;
      }
      break;

    case USER_ACTION.ATC_PRE_ORDER:
      eventName = ATTENTIVE_BOOST_EVENT.PRE_ORDER;
      break;
    default:
      break;
  }

  return {
    integration_name: INTEGRATION_NAME_ATTENTIVE,
    event_name: eventName,
    user_info: {
      email: userInfo?.email || '',
      phone: userInfo?.phone || '',
    },
  };
};
